import React from 'react';

import './ButtonCopy.scss';

const ButtonCopy = props => (
  <button type="button" onClick={props.onClick} className={`button button--copy ${props.extraClass ? `${props.extraClass}` : ''}`}>{props.children}</button>
);

export default ButtonCopy;
